module.exports = __webpack_public_path__ + "img/football.56ba0ef7.png";